<button class="btn d-flex align-items-center" *ngIf="hasPermission()" (click)="onSubmit()">
  <i class="bi bi-pencil-square p-2"></i>
</button>
